import { render } from "./CreateGameView.vue?vue&type=template&id=2acd2623"
import script from "./CreateGameView.vue?vue&type=script&lang=js"
export * from "./CreateGameView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__